export const TRANSACTION_NEW_POLICY = 'NEW_INSURANCE_PAYMENT';
export const TRANASCTION_INVOICE = 'INVOICE_PAYMENT';

export const TRANSACTION_STATUS_INITIATED = 'INITIATED';
export const TRANSACTION_STATUS_STARTED = 'STARTED';
export const TRANSACTION_STATUS_PAID = 'PAID';
export const TRANSACTION_STATUS_COMPLETED = 'COMPLETED';
export const TRANSACTION_STATUS_CANCELED = 'CANCELED';
export const TRANSACTION_STATUS_FAILED = 'FAILED';

export const TRANSACTION_STATUS_WAITING = 'WAITING';

export const TRANSACTION_ACTION_STATUS_REQUIRED = 'ACTION_REQUIRED';
export const TRANSACTION_ACTION_STATUS_DONE = 'DONE';
